module.exports = __webpack_public_path__ + "02ca85ecb3cc9804f938f07a6a07bce2.png";